import { ActionTree } from 'vuex'
import { FromAddressesStateInterface } from '@/models/store/FromAddressesState.interface'
import { RootStateInterface } from '@/models/store/RootState.interface'
import { fetchFromAddresses, createFromAddress } from '@/api_client'

const actions: ActionTree<FromAddressesStateInterface, RootStateInterface> = {
  async load({ commit }) {
    commit('loading')
    try {
      const response = await fetchFromAddresses()
      commit('updateFromAddresses', response.data)
    } finally {
      commit('loaded')
    }
  },
  async create({ commit, dispatch }, payload: { value: string }) {
    commit('saving')
    try {
      const fromAddress = await createFromAddress(payload)
      await dispatch('load')
      return fromAddress
    } finally {
      commit('saved')
    }
  }
}

export default actions
